export function dashboardErrorMessage(error, fallback) {
    const response = error && error.response;
    if (!response) return fallback;
    if (response.status === 401) return 'Votre session a expiré ou vos permissions ont changé. Veuillez vous reconnecter.';
    if (response.status === 403) return 'Vous ne disposez plus des autorisations nécessaires pour consulter ces données.';
    const message = response.data && response.data.message;
    return [422, 503].includes(response.status) && typeof message === 'string' && message.trim()
        ? message : fallback;
}

export function isDashboardDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
        && Number(value.slice(0, 4)) >= 1900 && Number(value.slice(0, 4)) <= 9998;
}

export function formatDashboardAmount(value) {
    if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return 'Non renseigné';
    return `${Number(value).toLocaleString('fr-FR', {maximumFractionDigits: 2})} FCFA`;
}
